module.exports = __webpack_public_path__ + "static/media/double-circle.92c1af2f.png";